<div>
    @if ($pricedItemNode()?.parameters; as parameters) {
        <cm-toggle [(toggle)]="parameters.dependsOnSubprice" matTooltip="Depends only on subprice?" matTooltipPosition="above"> </cm-toggle>
        @if ($variantConditionNode(); as condition) {
            <cm-variant-condition-node-settings [node]="condition"></cm-variant-condition-node-settings>
        }
    }
</div>
